<template>
  <button
    type="button"
    :class="[{ 'ps-opacity-25 ps-pointer-events-none': disabled }]"
    class="ps-cursor-pointer"
    @click="$emit('button-click')"
    @mouseenter="$emit('button-mouseenter')"
    @mouseleave="$emit('button-mouseleave')"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    disabled: Boolean,
    prevent: Boolean,
    stop: Boolean,
  },
  methods: {
    emitClick(e) {
      if (this.prevent) {
        e.preventDefault()
      }
      if (this.stop) {
        e.stopPropagation()
      }
      return this.$emit('button-click')
    }
  }
}
</script>
